
















































import Vue from "vue";
import { getLabScoreColor } from "@/features/coreWebVitals/utils/scoreEvaluation";

export default Vue.extend({
  props: {
    score: { type: Number },
    loading: { type: Boolean, required: true },
    isNoSelectDomain: { type: Boolean, required: true },
  },
  methods: {
    dataColorStyle() {
      return { color: getLabScoreColor(this.score) };
    },
    isNoData() {
      if (!this.isNoSelectDomain) {
        return this.score === null;
      }
      return false;
    },
  },
});
